export default {
    education_1: 'All Education Levels',
    education_101: 'Less than HS',
    education_102: 'HS graduate',
    education_103: 'Some college',
    education_104: 'College graduate',
};
